import { useState } from 'react';
import { Col, Image, Row } from 'react-bootstrap';

import ErrorImage from '@/ui/assets/ErrorImage';
import Icon from '@/ui/assets/Icon';

interface ISelectButtonProps {
  imageUrl?: string;
  icon?: string;
  label: string;
  secondaryLabel?: string;
  disabled?: boolean;
  actionButton: () => void;
}

/**
 * Componente Button estilos elección de opción
 * @component
 */
const SelectButton = ({ imageUrl = '', icon = '', label, secondaryLabel = '', disabled = false, actionButton }: ISelectButtonProps): JSX.Element => {
  /* Estado para controlar si el check está visible o no */
  const [isHovered, setIsHovered] = useState<boolean>(false);

  /* Función que se llama cuando el mouse entra al área del componente */
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  /* Función que se llama cuando el mouse sale del área del componente */
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <Row
      className={`g-0 d-flex align-items-center justify-content-between rounded rounded-3 mb-2 p-1 dropdown-item btn-select ${
        disabled ? 'disabled' : ''
      }`}
      onClick={actionButton}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <Col lg={2} className='d-flex align-items-center justify-content-center'>
        {imageUrl.length > 0 && (
          <div className='image-crud-container rounded rounded-3  me-3'>
            <Image
              fluid
              className='rounded rounded-3 image-full'
              src={imageUrl}
              alt={label}
              onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                e.currentTarget.src = ErrorImage;
              }}
            />
          </div>
        )}
        {icon.length > 0 && <Icon name={icon} classMain='px-2' />}
      </Col>
      <Col lg={6}>
        <div className='d-flex justify-content-lg-start justify-content-center align-items-center'>
          <p className='m-0 text-lg-start text-center text-wrap'>{label}</p>
        </div>
        {secondaryLabel.length > 0 && (
          <div className='d-flex justify-content-lg-start justify-content-center align-items-center'>
            <span className='m-0 text-lg-start text-center'>{secondaryLabel}</span>
          </div>
        )}
      </Col>
      <Col lg={4}>
        <span className='icon-selection text-center'>
          {isHovered && <Icon name='ico-selection' classMain='svg-tertiary-5 d-flex justify-content-center' />}
        </span>
      </Col>
    </Row>
  );
};

export default SelectButton;
